import { useCallback, useMemo } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminLayoutShell from "../../admin/navigation/AdminLayoutShell";
import { getUserTypeName } from "../../admin/navigation/adminNavigation";
import {
  customerSidebarFooter,
  CUSTOMER_PANEL_HOME,
  getCustomerBreadcrumbs,
  getCustomerPageTitle,
  getCustomerSidebar,
  isCustomerRoot,
} from "./customerNavigation";
import CustomerBreadcrumbs from "./CustomerBreadcrumbs";
import "../../admin/navigation/AdminShell.css";

const CustomerDashboardLayout = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const role = getUserTypeName(authState);

  // Empty while the role is unknown, so the wrong menu never flashes.
  const sections = useMemo(() => getCustomerSidebar(role), [role]);

  // Parent route used when there is no in-app history to go back to (e.g. a direct deep link)
  const getBackTarget = useCallback((pathname) => {
    if (isCustomerRoot(pathname)) return null;
    const crumbs = getCustomerBreadcrumbs(pathname);
    const parent = [...crumbs].reverse().find((crumb, i) => i > 0 && crumb.to);
    return parent?.to ?? CUSTOMER_PANEL_HOME;
  }, []);

  return (
    <AdminLayoutShell
      sections={sections}
      footerItems={sections.length ? customerSidebarFooter : []}
      staticHeadings
      homePath={CUSTOMER_PANEL_HOME}
      logoutRedirect="/login"
      titleGetter={getCustomerPageTitle}
      getBackTarget={getBackTarget}
    >
      <CustomerBreadcrumbs />
      {children ?? <Outlet />}
      {/* back/forward return to the same scroll position */}
      <ScrollRestoration />
    </AdminLayoutShell>
  );
};

export default CustomerDashboardLayout;
